import { CartItem } from "src/storefront/types/cart";
import { Catalog } from "src/storefront/types/catalog";


type CartItemEventStandardFields = {
  event: string;
  currency: string;
  value: number;
  items: CartItemEventItem[];
}

type CartItemEventItem = {
  // see https://developers.google.com/tag-platform/gtagjs/reference/events#purchase and
  // identical https://developers.google.com/tag-platform/gtagjs/reference/events#begin_checkout
  affiliation?: string;
  item_category?: string;
  item_category2?: string;
  item_category3: string;
  item_category4: string;
  item_category5?: string;
  item_name: string;
  variant: string;
  currency: string;
  price: number;
  quantity: number;
}

export type CartItemEvent = CartItemEventStandardFields;

export type CartItemEventItemDefaults = Pick<CartItemEventItem, 'affiliation' | 'item_category' | 'item_category2'>

export class CartItemEventSerializer {
  readonly catalog: Catalog;
  readonly itemDefaults: CartItemEventItemDefaults;

  constructor(catalog: Catalog, itemDefaults?: CartItemEventItemDefaults) {
    this.catalog = catalog;
    this.itemDefaults = itemDefaults || {};
  }

  addToCartEvent(cartItem: CartItem): CartItemEvent {
    return this.buildCartItemEvent("add_to_cart", cartItem);
  }

  removeFromCartEvent(cartItem: CartItem): CartItemEvent {
    return this.buildCartItemEvent("remove_from_cart", cartItem);
  }

  private buildCartItemEvent(event: string, cartItem: CartItem): CartItemEvent {
    const [section, category, subcategory] = this.catalog.findCatalogComponentsFromKeyPath(cartItem.keyPrefix);

    const item: CartItemEventItem = {
      ...this.itemDefaults,
      item_category3: section.title,
      item_category4: category.title,
      item_category5: subcategory?.title,
      item_name: cartItem.name,
      variant: cartItem.extrasDescription(),
      currency: "NZD",
      price: cartItem.price / 100,
      quantity: cartItem.quantity,
    }

    // Many of the CustomStoreField attributes are already present
    // in the datalayer from the previously added view_store event
    return {
      event: event,
      currency: "NZD",
      value: cartItem.price / 100,
      items: [item],
    }
  }
}
